import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class MassiveUpdateService {

  static ENV = environment;
  constructor(private httpService: HttpService) { }

  public massiveUpdate(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${MassiveUpdateService.ENV.environment.API.massive_update}`, data,  httpRequesthandler);
  }

  public getProcessAll(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${MassiveUpdateService.ENV.environment.API.get_process_tercero}`,  httpRequesthandler);
  }
  public getProcessId(id: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${MassiveUpdateService.ENV.environment.API.get_process_tercero_datail}/${id}`,  httpRequesthandler);
  }

  public proceesUpdate(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(`${MassiveUpdateService.ENV.environment.API.process_terc}`, data,  httpRequesthandler);
  }

  public deleteProcess(pk: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${MassiveUpdateService.ENV.environment.API.process_terc}/${pk}`,  httpRequesthandler);
  }

  public revokeTask(id: string, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${MassiveUpdateService.ENV.environment.API.revoke_task_celery}/${id}`,  httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/admin/massive-update.service.ts